export default "__VITE_ASSET__7343f229__"